import React, { useCallback, useState } from 'react';
import styles from '../../styles/ReporteSegurosEstudiantesStyles/ReporteSegurosEstudiantes.module.css';
import Sidebar, { useSidebar } from '../../components/Sidebar';
import HeaderGlobal from '../../components/HeaderGlobal';
import LoaderOverlay from '../../components/LoaderOverlay';
import FiltrosReporteSeguros from './FiltrosReporteSeguros';
import TablaReporteSeguros from './TablaReporteSeguros';
import { getReporteSegurosEstudiantes } from '../../api/reporteSegurosEstudiantes';

function ReporteSegurosEstudiantesScreen() {
  const { isCollapsed } = useSidebar();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [reportData, setReportData] = useState(null);
  const [contexto, setContexto] = useState({});

  const [filters, setFilters] = useState({
    id_campus: '',
    id_seccion: '',
    id_programa: '',
  });

  const handleFilterChange = useCallback((key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  }, []);

  const handleGenerate = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const data = await getReporteSegurosEstudiantes({
        id_campus: filters.id_campus,
        id_seccion: filters.id_seccion,
        id_programa: filters.id_programa,
      });
      setReportData(data);
    } catch (err) {
      console.error('[ReporteSegurosEstudiantesScreen] Error:', err);
      setError(err.message || 'No se pudo obtener el reporte.');
      setReportData(null);
    } finally {
      setLoading(false);
    }
  }, [filters]);

  return (
    <div className={styles.mainContainer}>
      <div className={`${styles.layout} ${isCollapsed ? styles.sidebarCollapsedLayout : ''}`}>
        <div className={styles.sidebarColumn}>
          <Sidebar />
        </div>
        <div className={styles.contentColumn}>
          <main className={styles.mainContent}>
            <HeaderGlobal title="Reporte Seguros Estudiantes" />
            <div className={styles.contentArea}>
              <div className={styles.contentWrapper} style={{ position: 'relative' }}>
                <LoaderOverlay visible={loading} label="Generando reporte..." />

                <FiltrosReporteSeguros
                  filters={filters}
                  onChange={handleFilterChange}
                  onGenerate={handleGenerate}
                  loading={loading}
                  onContextResolved={setContexto}
                />

                {error && (
                  <div
                    style={{
                      background: '#fdecea',
                      color: '#c5221f',
                      padding: '10px 14px',
                      borderRadius: 4,
                      marginBottom: 16,
                      fontSize: 13,
                    }}
                  >
                    {error}
                  </div>
                )}

                {reportData ? (
                  <div className={styles.reportContainer}>
                    <TablaReporteSeguros
                      resultados={reportData.resultados || []}
                      contexto={contexto}
                    />
                  </div>
                ) : (
                  <div className={styles.reportContainer}>
                    <div className={styles.emptyState}>
                      <div className={styles.emptyIcon}>🛡️</div>
                      <p className={styles.emptyText}>Sin reporte generado</p>
                      <p className={styles.emptySubText}>
                        Selecciona los filtros y presiona <strong>Generar Reporte</strong>.
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}

export default ReporteSegurosEstudiantesScreen;
